import { render, staticRenderFns } from "./SearchComment.vue?vue&type=template&id=448ae196&scoped=true&"
import script from "./SearchComment.vue?vue&type=script&lang=js&"
export * from "./SearchComment.vue?vue&type=script&lang=js&"
import style0 from "./SearchComment.vue?vue&type=style&index=0&id=448ae196&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ae196",
  null
  
)

export default component.exports